import React from 'react';
import { useTheme, jsx, Global } from '@emotion/react';
import { sxProp, css } from '@indeed/ifl-css';

const html = {
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  "*, *::before, *::after": {
    boxSizing: "inherit"
  }
};
const body = {
  "@media print": {
    // Save printer ink.
    backgroundColor: "white"
  },
  // Add support for document.body.requestFullScreen().
  // Other elements, if background transparent, are not supported.
  "&::backdrop": {
    backgroundColor: "background"
  }
};
const baseStyles = props => css({
  html,
  body,
  // apply root styles to the html and body
  "html, body": {
    variant: "styles.root"
  },
  // apply element styles from theme
  variant: "styles"
})(props.theme);

/**
 * @see https://experience.indeed.design/components/ids/global-styles
 */
const GlobalStyles = props => {
  const theme = useTheme();
  return jsx(React.Fragment, null, jsx(Global, {
    styles: baseStyles({
      ...props,
      theme
    })
  }), props.sx ? jsx(Global, {
    styles: sxProp({
      ...props,
      theme
    })
  }) : null);
};
GlobalStyles.displayName = "GlobalStyles";

export { GlobalStyles, body, html };
